import React from 'react';
import { Box, Heading, Flex } from '@chakra-ui/react';
import Wrapper from '@components/atoms/Wrapper';
import Link from '@components/atoms/Link';
import RichText from '@components/atoms/RichText';
import HeaderFont from '@components/atoms/HeaderFont';

import { SiTiktok } from '@react-icons/all-files/si/SiTiktok';
import { FiInstagram } from '@react-icons/all-files/fi/FiInstagram';
import { RiMessengerFill } from '@react-icons/all-files/ri/RiMessengerFill';
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight';

import { dataLayerClick } from '@helpers/dataLayerPush';

const getIcon = (icon) => {
  switch (icon) {
    case `TikTok`:
      return <SiTiktok />;
    case `Instagram`:
      return <FiInstagram />;
    case `Messenger`:
      return <RiMessengerFill />;
    default:
      return <FiArrowRight />;
  }
};

const ContactBlock = ({
  data: {
    socialMediaTitle,
    socialButtons,
    emailTitle,
    email,
    addressTitle,
    address
  }
}) => {
  return (
    <Wrapper medium>
      <Flex
        flexDirection={{ base: `column`, md: `row` }}
        justifyContent="space-between"
        mb="14">
        <Box w={{ base: `100%`, md: `40%` }} mb={{ base: `4`, md: `0` }}>
          <Heading
            as="h2"
            color="purple.600"
            fontWeight="900"
            size="md"
            fontStyle="italic"
            textTransform="uppercase"
            mb="4">
            {socialMediaTitle}
          </Heading>

          {socialButtons.map((item, i) => (
            <Box key={`socialButtons${i + 1}`} mb="4">
              <Link
                href={item.buttonLink}
                variant="ghostButton"
                w="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                target={item.newWindow ? `_blank` : `_self`}
                lineHeight="unset"
                onClick={() => {
                  dataLayerClick({
                    event: `cta_click`,
                    clickText: item.buttonText,
                    clickUrl: item.buttonLink
                  });
                }}>
                {getIcon(item.socialIcon)}
                <HeaderFont
                  fontWeight="700"
                  textTransform="uppercase"
                  ml="2"
                  mt="2px">
                  {item.buttonText}
                </HeaderFont>
              </Link>
            </Box>
          ))}
        </Box>
        <Box w={{ base: `100%`, md: `20%` }} mb={{ base: `4`, md: `0` }}>
          <Heading
            as="h2"
            color="purple.600"
            fontWeight="900"
            size="md"
            fontStyle="italic"
            textTransform="uppercase"
            mb="4">
            {emailTitle}
          </Heading>

          <RichText data={email.data.email} />
        </Box>
        <Box w={{ base: `100%`, md: `20%` }} mb={{ base: `4`, md: `0` }}>
          <Heading
            as="h2"
            color="purple.600"
            fontWeight="900"
            size="md"
            fontStyle="italic"
            textTransform="uppercase"
            mb="4">
            {addressTitle}
          </Heading>

          <RichText data={address.data.address} />
        </Box>
      </Flex>
    </Wrapper>
  );
};

export default ContactBlock;
